import { render, staticRenderFns } from "./popoverLangsComp.vue?vue&type=template&id=0e25a324&scoped=true"
import script from "./popoverLangsComp.vue?vue&type=script&lang=js"
export * from "./popoverLangsComp.vue?vue&type=script&lang=js"
import style0 from "./popoverLangsComp.vue?vue&type=style&index=0&id=0e25a324&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e25a324",
  null
  
)

export default component.exports